var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Wallets"},[_vm._m(0),_c('div',{staticClass:"panel"},[_c('wallet-statistics'),_c('hr'),_c('active-wallet-users')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-title"},[_vm._v("Wallets")])])
}]

export { render, staticRenderFns }